var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.437,
    height: 37.143,
    viewBox: "0 0 41.437 37.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.222,3H8.216A6.2,6.2,0,0,0,2,9.19V25.7a6.2,6.2,0,0,0,6.216,6.19H20.647v4.127H12.359a2.063,2.063,0,1,0,0,4.127H33.078a2.063,2.063,0,1,0,0-4.127H24.791V31.889H37.222a6.2,6.2,0,0,0,6.216-6.19V9.19A6.2,6.2,0,0,0,37.222,3Zm2.072,22.7a2.068,2.068,0,0,1-2.072,2.063H8.216A2.068,2.068,0,0,1,6.144,25.7V9.19A2.068,2.068,0,0,1,8.216,7.127H37.222A2.068,2.068,0,0,1,39.294,9.19Z",
    transform: "translate(-2 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.4f2bf2f44dd38f7f2655776b83fb0c2b.svg";
export { ForwardRef as ReactComponent };